const BLUE_STATUS = [
  'blue',
  'ok',
  'running',
  'processing',
  'active',
  'using',
  'user',
  'valid',
  'public',
  'runnable',
  'run',
  '3xx',
  'online',
  'bound',
];
const GREEN_STATUS = [
  'green',
  'normal',
  'succeeded',
  'complete',
  'completion',
  'available',
  'ready',
  'connection',
  'connect',
  'up',
  'admin',
  'finished',
  'true',
  '2xx',
  'low',
  'profiled',
  'on',
];
const YELLOW_STATUS = [
  'yellow',
  'idle',
  'master',
  'waiting',
  'pending',
  'warning',
  'suspended',
  'dormant',
  'not_present',
  'lower_layer_down',
  'notready',
  'stop',
  'connecting',
  '4xx',
  'expiring-soon',
  'medium',
  'not-profiled',
  'released',
];
const RED_STATUS = [
  'red',
  'timed-waiting',
  'error',
  'exception',
  'critical',
  // 'terminated',
  'terminating',
  'down',
  'false',
  'fail',
  'failed',
  'failure-target',
  'abnormal',
  'timeout',
  '5xx',
  'end-of-life',
  'offline',
  'high',
  'lost',
];
export const DISABLED_STATUS = ['blocked'];
// NOTE: For Test
export const GRAY_STATUS = [
  'gray',
  'none',
  'disabled',
  'no-signal',
  'inactive',
  'unknown',
  'no-data',
  'combination',
  'and',
  'or',
  'tag',
  'target',
  'off',
  'testing',
  'exited',
  'snoozing',
  'diskpressure',
  'pidpressure',
  'networkunavailable',
  'stopped',
  'stopping',
  'terminated',
  'unsupported',
  'detached',
  'attaching',
];
export const STATUS_SET = {
  BLUE: BLUE_STATUS,
  GREEN: GREEN_STATUS,
  YELLOW: YELLOW_STATUS,
  RED: RED_STATUS,
  DISABLED: DISABLED_STATUS,
};
